module.exports = __webpack_public_path__ + "img/BatAgriSerreG.73c888e2.png";